import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  pure: false 
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: string | Date): string {
    if (!value) return '';

    const time = new Date(value);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - time.getTime()) / 1000);

    // Define intervals in seconds
    const intervals: Record<string, number> = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60,
      'second': 1
    };
    
    // Logic to determine the correct time ago string
    for (const intervalName in intervals) {
      const intervalValue = intervals[intervalName];
      if (seconds >= intervalValue) {
        const count = Math.floor(seconds / intervalValue);
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }

    return 'just now';
  }
}